import PrimaryButton from './PrimaryButton.js';

export default PrimaryButton;
